import { IWithChildren } from 'types';
import classNames from 'classnames';
import React, { ForwardedRef } from 'react';
import styles from './styles.module.scss';

export type ButtonProps = { className?: string, type?: 'submit' | 'reset' | 'button', block?: boolean } & React.HTMLProps<HTMLButtonElement>;

export type LinkProps = { className?: string, type?: 'submit' | 'reset' | 'button', block?: boolean } & React.HTMLProps<HTMLAnchorElement>;

export const Button = (
  {
    block, children, className, ...props
  }: Partial<IWithChildren> & ButtonProps,
) => (
  // eslint-disable-next-line react/button-has-type
  <button className={classNames(styles.box, { [styles.block]: block }, className)} {...props}>
    {children}
  </button>
);

export const Link = React.forwardRef((
  {
    block, children, className, ...props
  }: Partial<IWithChildren> & LinkProps, ref: ForwardedRef<HTMLAnchorElement>,
) => (
  <a ref={ref} className={classNames(styles.box, { [styles.block]: block }, className)} {...props}>
    {children}
  </a>
));
